import React from "react";

/**
 * Shown when the domain's data could not be loaded because of a network /
 * server error (as opposed to "not found", which SiteResolver already
 * handles). Gives the visitor a way to retry instead of a blank page.
 */
export default function SiteErrorState({ theme = "personal", onRetry }) {
    const accent = theme === "business" ? "#1f6b45" : "#2563eb";

    return (
        <div
            role="alert"
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 12,
                minHeight: "100vh",
                textAlign: "center",
                padding: 24,
                background: "#f8f9fa",
                fontFamily: "Inter, system-ui, sans-serif",
            }}
        >
            <i className="bi bi-wifi-off" style={{ fontSize: 40, color: accent }} aria-hidden="true" />
            <h2 style={{ fontWeight: 700, margin: 0, fontSize: 22 }}>Something went wrong</h2>
            <p style={{ color: "#6b7280", maxWidth: 420, margin: 0 }}>
                We couldn't load this site right now. Please check your connection and try again.
            </p>
            {onRetry && (
                <button
                    type="button"
                    onClick={onRetry}
                    style={{
                        marginTop: 8,
                        background: accent,
                        color: "#fff",
                        border: "none",
                        borderRadius: 999,
                        padding: "10px 22px",
                        fontWeight: 700,
                        cursor: "pointer",
                    }}
                >
                    Try Again
                </button>
            )}
        </div>
    );
}
